import * as types from '../actions/actionTypes';

const initialState = {
  users: [],
  selectedUser: null,
  userRoles: [],
  userActivity: null,
  statistics: null,
  hierarchy: null,
  organizationChart: null,
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Users
    case types.FETCH_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.users,
        pagination: action.payload.pagination,
        error: null,
      };
    case types.FETCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch Single User
    case types.FETCH_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedUser: action.payload,
        error: null,
      };
    case types.FETCH_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Create User
    case types.CREATE_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: [action.payload.user, ...state.users],
        error: null,
      };
    case types.CREATE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Update User
    case types.UPDATE_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user
        ),
        selectedUser: action.payload,
        error: null,
      };
    case types.UPDATE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Delete User
    case types.DELETE_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.filter((user) => user.id !== action.payload),
        error: null,
      };
    case types.DELETE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Toggle User Status
    case types.TOGGLE_USER_STATUS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.TOGGLE_USER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user
        ),
        selectedUser: action.payload,
        error: null,
      };
    case types.TOGGLE_USER_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Reset User Password
    case types.RESET_USER_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };
    case types.RESET_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.RESET_USER_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Verify User
    case types.VERIFY_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.VERIFY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user
        ),
        selectedUser: action.payload,
        error: null,
      };
    case types.VERIFY_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // User Roles
    case types.FETCH_USER_ROLES_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_USER_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        userRoles: action.payload,
        error: null,
      };
    case types.FETCH_USER_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.ASSIGN_USER_ROLES_REQUEST:
      return { ...state, loading: true, error: null };
    case types.ASSIGN_USER_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedUser: action.payload,
        error: null,
      };
    case types.ASSIGN_USER_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // User Activity
    case types.FETCH_USER_ACTIVITY_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_USER_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        userActivity: action.payload,
        error: null,
      };
    case types.FETCH_USER_ACTIVITY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Statistics
    case types.FETCH_USER_STATISTICS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_USER_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        statistics: action.payload,
        error: null,
      };
    case types.FETCH_USER_STATISTICS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Hierarchy
    case types.FETCH_USER_HIERARCHY_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_USER_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        hierarchy: action.payload,
        error: null,
      };
    case types.FETCH_USER_HIERARCHY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Organization Chart
    case types.FETCH_ORGANIZATION_CHART_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_ORGANIZATION_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        organizationChart: action.payload,
        error: null,
      };
    case types.FETCH_ORGANIZATION_CHART_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default userReducer;